module.exports = __webpack_public_path__ + "img/root101.801d7927.png";